export type ScriptScrollTarget = {
  episodeNo: number
  sceneNo: number | null
}

function parseScrollMarker(el: Element): ScriptScrollTarget | null {
  const raw = el.getAttribute('data-scroll-marker')
  if (!raw) return null
  if (raw.startsWith('scene:')) {
    const [, ep, sc] = raw.split(':')
    const episodeNo = Number.parseInt(ep ?? '', 10)
    const sceneNo = Number.parseInt(sc ?? '', 10)
    if (!Number.isNaN(episodeNo) && !Number.isNaN(sceneNo)) {
      return { episodeNo, sceneNo }
    }
    return null
  }
  if (raw.startsWith('episode:')) {
    const episodeNo = Number.parseInt(raw.slice('episode:'.length), 10)
    if (!Number.isNaN(episodeNo)) return { episodeNo, sceneNo: null }
  }
  return null
}

/** 先定当前集，再在该集内定场次，避免跨集场次抢占 */
export function pickScriptScrollTarget(
  root: HTMLElement,
  anchorOffset = 96,
): ScriptScrollTarget | null {
  const rootRect = root.getBoundingClientRect()
  const anchorY = rootRect.top + Math.min(anchorOffset, rootRect.height * 0.2)

  const episodeEls = Array.from(root.querySelectorAll('[data-scroll-marker^="episode:"]'))
  if (!episodeEls.length) return null

  let activeEpisode: number | null = null
  let bestEpTop = -Infinity

  for (const el of episodeEls) {
    const parsed = parseScrollMarker(el)
    if (!parsed) continue
    const top = el.getBoundingClientRect().top
    if (top <= anchorY + 4 && top > bestEpTop) {
      bestEpTop = top
      activeEpisode = parsed.episodeNo
    }
  }

  if (activeEpisode == null) {
    let firstBelow: { episodeNo: number; top: number } | null = null
    for (const el of episodeEls) {
      const parsed = parseScrollMarker(el)
      if (!parsed) continue
      const top = el.getBoundingClientRect().top
      if (top > anchorY && (!firstBelow || top < firstBelow.top)) {
        firstBelow = { episodeNo: parsed.episodeNo, top }
      }
    }
    activeEpisode = firstBelow?.episodeNo ?? null
  }

  if (activeEpisode == null) return null

  const sceneEls = Array.from(
    root.querySelectorAll(`[data-scroll-marker^="scene:${activeEpisode}:"]`),
  )
  let bestScene: { sceneNo: number; top: number } | null = null
  for (const el of sceneEls) {
    const parsed = parseScrollMarker(el)
    if (!parsed?.sceneNo) continue
    const top = el.getBoundingClientRect().top
    if (top <= anchorY + 4 && (!bestScene || top > bestScene.top)) {
      bestScene = { sceneNo: parsed.sceneNo, top }
    }
  }

  if (bestScene) return { episodeNo: activeEpisode, sceneNo: bestScene.sceneNo }
  return { episodeNo: activeEpisode, sceneNo: null }
}
